import moment from "moment";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";

export const ImprimirMovimiento = (movimiento) => {
    if (!movimiento) return;

    const {
        id,
        fecha,
        tipo,
        notas,
        monto,
        Usuario,
        pagoCompras = []
    } = movimiento;

    const empleadoNombre = Usuario?.Empleados?.[0]?.nombreCompleto || "—";
    const fechaHora = moment(fecha).format("DD-MM-YYYY HH:mm:ss");
    const pagoDetalle = pagoCompras[0]?.pago || {};

    const html = `
        <div style="width:280px; font-family:'Arial', sans-serif; font-size:12px; color:black; padding:0; margin:0;">
            <img src="${NegocioConfig.logo}" style="width:80px; height:80px; display:block; margin:0 auto;" alt="Logo" />
            <div style="text-align:center; margin-bottom:5px;">
                <div style="font-weight:bold; font-size:14px;">${NegocioConfig.nombre}</div>
                <div>${NegocioConfig.direccion}</div>
                <div>RTN: ${NegocioConfig.rtn}</div>
            </div>

            <div style="text-align:center; font-weight:bold; margin:10px 0; font-size:14px; border-top:1px dashed black; border-bottom:1px dashed black; padding:5px 0;">
                COMPROBANTE DE ${tipo.toUpperCase()}
            </div>

            <div style="margin-bottom:5px;"><span>N° Registro:</span> ${String(id).padStart(5, '0')}</div>
            <div style="margin-bottom:5px;"><span>Fecha:</span> ${fechaHora}</div>
            <div style="margin-bottom:5px;"><span>Responsable:</span> ${empleadoNombre}</div>
            
            <hr style="border:1px dashed black; margin: 5px 0;" />
            
            <div style="margin:5px 0;">
                <div style="font-weight:bold;">Concepto/Notas:</div>
                <div>${notas || "Sin observaciones"}</div>
            </div>

            <hr style="border:1px dashed black; margin: 5px 0;" />

            <div style="font-size:13px;">
                <table style="width:100%;">
                    <tr>
                        <td style="font-weight:bold;">TOTAL ${tipo.toUpperCase()}:</td>
                        <td style="text-align:right; font-weight:bold;">${formatoMoneda(monto)}</td>
                    </tr>
                </table>
            </div>

            ${pagoDetalle.pagotarjeta?.length > 0 || pagoDetalle.pagotransferencia?.length > 0 ? `
                <div style="margin-top:5px; font-size:11px;">
                    <div style="font-weight:bold; text-decoration:underline;">Detalle de Pago:</div>
                    ${pagoDetalle.pagotarjeta?.map(t => `<div>Tarjeta: ${formatoMoneda(t.monto)} (Ref: ${t.referencia})</div>`).join('')}
                    ${pagoDetalle.pagotransferencia?.map(t => `<div>Transf: ${formatoMoneda(t.monto)} (Ref: ${t.referencia})</div>`).join('')}
                </div>
            ` : ''}

            <div style="margin-top:10px; font-size:10px; text-transform:uppercase; text-align: center;">
                ${NumeroALetras(monto)}
            </div>

            <div style="text-align:center; margin-top:30px;">
                <div style="border-top:1px solid black; width:150px; margin:0 auto;"></div>
                <div style="font-size:11px;">Firma del Responsable</div>
            </div>

            <div style="text-align:center; margin-top:15px; font-size:10px;">
                Generado por Sistema de Gestión
            </div>
        </div>
    `;

    ImprimirEnIframe(html);
};